var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('AppNotifications'),(_vm.getIsAppLoading)?_c('AppLoader'):_vm._e(),_c('Header'),_c('router-view'),_c('Footer'),(!!_vm.getQuicKViewProduct)?_c('QuickView'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }